<div  *ngIf="!multiLine" class="input-field">
  <input type="text" [id]="id" (change)="textOnChange($event.target.value)"/>
  <label [for]="id">{{labelText}}</label>
</div>

<div *ngIf="multiLine" class="input-field">
  <textarea [id]="id" (change)="textOnChange($event.target.value)" [rows]="rowsMultiLine"></textarea>
  <label [for]="id">{{labelText}}</label>
</div>
